import React from 'react';
import { Box, Typography } from '@mui/material';
import { makeStyles } from '@mui/styles';
import { Theme } from '@mui/material/styles';
import { useTranslation } from 'react-i18next';
import LockClockOutlinedIcon from '@mui/icons-material/LockClockOutlined';

const useStyles = makeStyles<Theme>((theme) => ({
  root: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    padding: theme.spacing(2),
    backgroundColor: theme.palette.background.paper,
    borderRadius: theme.shape.borderRadius,
    margin: theme.spacing(2, 0),
  },
  icon: {
    marginRight: theme.spacing(1),
    color: theme.palette.text.secondary,
    fontSize: '1.5rem',
  },
}));

interface UnderDevelopmentProps {
  className?: string;
}

export function UnderDevelopment({ className }: UnderDevelopmentProps) {
  const classes = useStyles();
  const { t } = useTranslation();

  return (
    <Box className={`${classes.root} ${className || ''}`}>
      <LockClockOutlinedIcon className={classes.icon} />
      <Typography variant="h6" color="textSecondary">
        {t('common.underDevelopment')}
      </Typography>
    </Box>
  );
}
